import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, InputGroup, Form, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FaStar, FaTrash, FaPlus, FaSearch, FaCopy, FaSortUp, FaSortDown, FaSort } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';
import ModalNovoPortador from './ModalNovoPortador';
import ModalCopiarPortador from './ModalCopiarPortador';

var PortadorUsuario = function () {
  var _useState = function (val) { return useState(val); };

  var portadoresState = _useState([]);
  var portadores = portadoresState[0]; var setPortadores = portadoresState[1];
  var loadingState = _useState(false);
  var loading = loadingState[0]; var setLoading = loadingState[1];
  var filtroUsuarioState = _useState(null);
  var filtroUsuario = filtroUsuarioState[0]; var setFiltroUsuario = filtroUsuarioState[1];
  var usuariosState = _useState([]);
  var usuarios = usuariosState[0]; var setUsuarios = usuariosState[1];
  var mostrarModalNovoState = _useState(false);
  var mostrarModalNovo = mostrarModalNovoState[0]; var setMostrarModalNovo = mostrarModalNovoState[1];
  var mostrarModalCopiaState = _useState(false);
  var mostrarModalCopia = mostrarModalCopiaState[0]; var setMostrarModalCopia = mostrarModalCopiaState[1];
  var confirmacaoState = _useState({ show: false, item: null });
  var confirmacao = confirmacaoState[0]; var setConfirmacao = confirmacaoState[1];

  // Ordenação
  var ordenacaoState = _useState({ campo: 'codigo_usuario', direcao: 'asc' });
  var ordenacao = ordenacaoState[0]; var setOrdenacao = ordenacaoState[1];

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  useEffect(function () {
    carregarUsuariosFiltro();
  }, []);

  var carregarUsuariosFiltro = async function () {
    try {
      var resp = await api.listarUsuariosAtivosPortador();
      setUsuarios(
        (resp || []).map(function (u) {
          return {
            value: u.codigo,
            label: u.codigo + ' - ' + u.nome,
            searchText: (u.codigo + ' ' + (u.nome || '') + ' ' + (u.login || '')).toLowerCase()
          };
        })
      );
    } catch (e) {
      toast.error('Erro ao carregar lista de usuários.');
    }
  };

  var carregarPortadores = async function (codigoUsuario) {
    setLoading(true);
    try {
      var resp = await api.listarPortadoresUsuario(codigoUsuario);
      setPortadores(resp || []);
    } catch (e) {
      toast.error('Erro ao carregar portadores.');
    } finally {
      setLoading(false);
    }
  };

  var handleFiltrar = function () {
    if (!filtroUsuario) {
      toast.warn('Selecione um usuário para filtrar.');
      return;
    }
    carregarPortadores(filtroUsuario.value);
  };

  var handleLimparFiltro = function () {
    setFiltroUsuario(null);
    setPortadores([]);
  };

  var handleExcluir = function (item) {
    setConfirmacao({ show: true, item: item });
  };

  var handleConfirmarExclusao = async function (confirmado) {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    var item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.excluirPortadorUsuario({
        codigo_usuario: item.codigo_usuario,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
        conta_portador: item.conta_portador,
      });
      toast.success('Vínculo excluído com sucesso.');
      if (filtroUsuario) carregarPortadores(filtroUsuario.value);
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao excluir vínculo.');
    }
  };

  var handleMarcarPrincipal = async function (item) {
    try {
      await api.marcarPortadorPrincipal({
        codigo_usuario: item.codigo_usuario,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
        conta_portador: item.conta_portador,
      });
      toast.success('Portador marcado como principal.');
      if (filtroUsuario) carregarPortadores(filtroUsuario.value);
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao marcar portador principal.');
    }
  };

  var handleSalvarNovo = function () {
    setMostrarModalNovo(false);
    toast.success('Vínculo incluído com sucesso.');
    if (filtroUsuario) carregarPortadores(filtroUsuario.value);
  };

  var handleCopiarConcluido = function () {
    setMostrarModalCopia(false);
    if (filtroUsuario) carregarPortadores(filtroUsuario.value);
  };

  var portadoresOrdenados = portadores.slice().sort(function (a, b) {
    var campo = ordenacao.campo;
    var dir = ordenacao.direcao === 'asc' ? 1 : -1;
    var valA = a[campo]; var valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (typeof valA === 'string') {
      return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  var itemExclusao = confirmacao.item;

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .portador-desktop { display: block; }\
        .portador-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .portador-desktop { display: none !important; }\
          .portador-mobile  { display: block; }\
          .portador-filtro-row { flex-direction: column; }\
          .portador-filtro-row .text-right { text-align: right !important; margin-top: 8px; }\
        }\
      '}</style>

      <Header title="Portador Usuário" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center portador-filtro-row">
            <Col md={4}>
              <Select
                placeholder="Buscar por código, nome ou login..."
                options={usuarios}
                value={filtroUsuario}
                onChange={setFiltroUsuario}
                isClearable
                components={{ DropdownIndicator }}
                styles={customStyles}
                filterOption={function (option, inputValue) {
                  if (!inputValue) return true;
                  return option.data.searchText.indexOf(inputValue.toLowerCase()) >= 0;
                }}
              />
            </Col>
            <Col md={4} className="d-flex gap-2 mt-2 mt-md-0">
              <Button size="sm" variant="primary" onClick={handleFiltrar}>
                <FaSearch className="mr-1" /> Filtrar
              </Button>
              <Button size="sm" variant="secondary" className="ml-1" onClick={handleLimparFiltro}>
                Limpar
              </Button>
            </Col>
            <Col md={4} className="text-right mt-2 mt-md-0">
              {filtroUsuario && (
                <Button size="sm" variant="success" className="mr-1" onClick={function () { setMostrarModalNovo(true); }}>
                  <FaPlus className="mr-1" /> Novo
                </Button>
              )}
              <Button size="sm" variant="outline-primary" onClick={function () { setMostrarModalCopia(true); }}>
                <FaCopy className="mr-1" /> Copiar para outro GE
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            {filtroUsuario
              ? 'Portadores do usuário ' + filtroUsuario.label
              : 'Portadores'}
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({portadoresOrdenados.length} {portadoresOrdenados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {portadoresOrdenados.length === 0 ? (
            <p className="text-muted text-center my-4">
              {filtroUsuario ? 'Nenhum registro encontrado para este usuário.' : 'Selecione um usuário e clique em Filtrar para visualizar os portadores.'}
            </p>
          ) : (
            <>
              {/* Desktop */}
              <div className="portador-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={Object.assign({ width: '90px' }, thSortStyle)} onClick={function () { handleOrdenacao('codigo_usuario'); }}>Usuário{iconeOrdenacao('codigo_usuario')}</th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('nome_usuario'); }}>Nome{iconeOrdenacao('nome_usuario')}</th>
                      <th style={Object.assign({ width: '70px' }, thSortStyle)} onClick={function () { handleOrdenacao('codigo_grupo_empresa'); }}>GE{iconeOrdenacao('codigo_grupo_empresa')}</th>
                      <th style={Object.assign({ width: '90px' }, thSortStyle)} onClick={function () { handleOrdenacao('conta_portador'); }}>Portador{iconeOrdenacao('conta_portador')}</th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('apelido_conta'); }}>Descrição{iconeOrdenacao('apelido_conta')}</th>
                      <th style={{ width: '90px', textAlign: 'center' }}>Principal</th>
                      <th style={{ width: '100px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {portadoresOrdenados.map(function (item, idx) {
                      return (
                        <tr key={idx}>
                          <td>{item.codigo_usuario}</td>
                          <td>{item.nome_usuario}</td>
                          <td>{item.codigo_grupo_empresa}</td>
                          <td>{item.conta_portador}</td>
                          <td>{item.apelido_conta}</td>
                          <td className="text-center">
                            {item.principal === 'S' ? (
                              <Badge variant="success">Sim</Badge>
                            ) : (
                              <Badge variant="secondary">Não</Badge>
                            )}
                          </td>
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            {item.principal !== 'S' && (
                              <Button
                                size="sm"
                                variant="outline-warning"
                                title="Marcar como principal"
                                className="mr-1"
                                onClick={function () { handleMarcarPrincipal(item); }}
                              >
                                <FaStar />
                              </Button>
                            )}
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              onClick={function () { handleExcluir(item); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="portador-mobile p-2">
                {portadoresOrdenados.map(function (item, idx) {
                  return (
                    <Card key={idx} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{item.nome_usuario}</strong>
                            <br />
                            <small className="text-muted">Usuário: {item.codigo_usuario} | GE: {item.codigo_grupo_empresa}</small>
                          </div>
                          {item.principal === 'S' ? (
                            <Badge variant="success">Principal</Badge>
                          ) : (
                            <Badge variant="secondary">Não principal</Badge>
                          )}
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2" style={{ fontSize: '0.85rem' }}>
                          <span>Portador: <strong>{item.conta_portador}</strong> — {item.apelido_conta}</span>
                        </div>
                        <div className="d-flex justify-content-end gap-1">
                          {item.principal !== 'S' && (
                            <Button size="sm" variant="outline-warning" className="mr-1" onClick={function () { handleMarcarPrincipal(item); }}>
                              <FaStar className="mr-1" /> Principal
                            </Button>
                          )}
                          <Button size="sm" variant="outline-danger" onClick={function () { handleExcluir(item); }}>
                            <FaTrash className="mr-1" /> Excluir
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <ModalConfirmacao
        show={confirmacao.show}
        title="Confirmar Exclusão"
        message={
          itemExclusao
            ? 'Deseja excluir o vínculo do portador ' + itemExclusao.conta_portador + ' (' + itemExclusao.apelido_conta + ') para o usuário ' + itemExclusao.nome_usuario + ' no GE ' + itemExclusao.codigo_grupo_empresa + '?'
            : ''
        }
        onClose={handleConfirmarExclusao}
      />

      <ModalNovoPortador
        mostrar={mostrarModalNovo}
        onFechar={function () { setMostrarModalNovo(false); }}
        onSalvar={handleSalvarNovo}
        usuarioFixo={filtroUsuario}
        portadoresExistentes={portadores}
      />

      <ModalCopiarPortador
        mostrar={mostrarModalCopia}
        onFechar={function () { setMostrarModalCopia(false); }}
        onConcluido={handleCopiarConcluido}
      />
    </Container>
  );
};

export default PortadorUsuario;
